import { render, staticRenderFns } from "./upload-box.vue?vue&type=template&id=a923c6e4&scoped=true&"
import script from "./upload-box.vue?vue&type=script&lang=js&"
export * from "./upload-box.vue?vue&type=script&lang=js&"
import style0 from "./upload-box.vue?vue&type=style&index=0&id=a923c6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a923c6e4",
  null
  
)

export default component.exports